module.exports = __webpack_public_path__ + "img/express-delivery-big.b9a8ad6.svg";